import { useI18n } from '@/i18n/context';
import { LANGUAGE_NATIVE_NAMES, LANGUAGES } from '@/i18n/core';
import styles from './LanguageSwitcher.module.css';

/**
 * "العربية | English" — text only, no flags (brief §7).
 * Each option is labelled in its own language and marked with its lang attribute.
 */
export function LanguageSwitcher({ tone = 'light', onChange }: { tone?: 'light' | 'dark'; onChange?: (lang: 'ar' | 'en') => void }) {
  const { language, setLanguage, t } = useI18n();
  return (
    <div className={[styles.switcher, tone === 'dark' ? styles.dark : ''].join(' ')} role="group" aria-label={t.common.language}>
      {LANGUAGES.map((lang, i) => (
        <span key={lang} className={styles.item}>
          {i > 0 && (
            <span className={styles.separator} aria-hidden="true">
              |
            </span>
          )}
          <button
            type="button"
            lang={lang}
            dir={lang === 'ar' ? 'rtl' : 'ltr'}
            className={styles.option}
            aria-pressed={language === lang}
            onClick={() => {
              setLanguage(lang);
              onChange?.(lang);
            }}
          >
            {LANGUAGE_NATIVE_NAMES[lang]}
          </button>
        </span>
      ))}
    </div>
  );
}
